import styled from 'styled-components';

export const StoresLinksStyles = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  max-width: 380px;
  width: 100%;
  margin: 0 auto 14px;

  a {
    display: block;
    aspect-ratio: 1 / 0.29;
    width: 166px;
    font-size: 0;
    line-height: 0;

    @media screen and (min-width: 576px) {
      width: 168px;
    }

    img {
      height: 100%;
      width: 100%;
    }
  }
`;
